import React from "react";
import MainContentCard from "../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import MyTCProfileViewChild from "./MyTCProfileViewChild";

const MyTCProfileView = () => {
  return (
    <MainContentCard>
      <ErrorBoundaryRoutes route="/tc-profile" page="MyTCProfileView">
        <MyTCProfileViewChild />
      </ErrorBoundaryRoutes>
    </MainContentCard>
  );
};

export default MyTCProfileView;
